import { ModuleLink } from "components/common/moduleNavigation/moduleTypes/moduleTypes";
import chairIcon from "assets/images/moduleNavigationIcons/chair.svg";
import { Unloadings } from "routes/wms/Unloadings";

export const products: ModuleLink = {
  url: "products",
  label: "Produkty",
  icon: chairIcon,
  subSection: <></>,
  routing: Unloadings,
  isAccessible: false,
};
